import request from '@/utils/request'

const creditLetterDetailApi = {
  trade_credit_letter_detail_list: '/trade/credit_letter_detail/',
  trade_credit_letter_detail_create: '/trade/credit_letter_detail/',
  trade_credit_letter_detail_update: '/trade/credit_letter_detail/',
  trade_credit_letter_detail_delete: '/trade/credit_letter_detail/'
}

/**
 * 列表
 */
export function credit_letter_detail_list (parameter) {
  return request({
    url: creditLetterDetailApi.trade_credit_letter_detail_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function credit_letter_detail_create (parameter) {
  return request({
    url: creditLetterDetailApi.trade_credit_letter_detail_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function credit_letter_detail_update (parameter, corporation_id) {
  return request({
    url: creditLetterDetailApi.trade_credit_letter_detail_update + corporation_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function credit_letter_detail_delete (corporation_id) {
  return request({
    url: creditLetterDetailApi.trade_credit_letter_detail_delete + corporation_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
